import React from 'react';
import { Box, Paper, Grid, Typography, Tooltip, IconButton, Checkbox } from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
const moment = require('moment');

const formatCurrency = (value) => {
    if (typeof value === 'number') {
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value);
    }
    return '€0,00';
};

const formatDate = (d) => (d ? moment(d).format('DD/MM/YY') : '');

const getStatusColor = (att) => {
    if (att.idpagamento) return '#4caf50';    // Green (Paid)
    if (att.idfattura) return '#ff9800';      // Orange (Invoiced)
    if (att.avanzamento === 100) return '#2196f3'; // Blue (Completed)
    return '#e0e0e0';                         // Grey (Open)
};

const AttivitaCard = ({ attivita: att, selectable, selected, onToggleSelect, onClick }) => {
    const statusColor = getStatusColor(att);
    const total = Number(att.valoreattivitaprogetto || 0) * Number(att.quantita_attivita || 1);

    return (
        <Paper
            elevation={0}
            sx={{
                mb: 1.5, p: 2,
                border: '1px solid', borderColor: 'divider',
                borderLeft: `6px solid ${statusColor}`,
                borderRadius: 3, bgcolor: 'background.paper',
                transition: 'all 0.2s',
                cursor: att.idfattura ? 'default' : 'pointer',
                '&:hover': {
                    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                    transform: att.idfattura ? 'none' : 'translateY(-2px)',
                    borderColor: 'primary.light',
                },
            }}
            onClick={() => onClick(att)}
        >
            <Grid container alignItems="center" spacing={2}>
                {/* Checkbox sempre visibile per attività selezionabili (completate e non fatturate) */}
                <Grid item xs={1} sm={1}>
                    {selectable && (
                        <Checkbox
                            checked={selected}
                            onChange={() => onToggleSelect(att.idattivita)}
                            onClick={(e) => e.stopPropagation()}
                            size="small"
                        />
                    )}
                </Grid>

                {/* Sigla */}
                <Grid item xs={2} sm={1}>
                    <Box sx={{ bgcolor: `${statusColor}15`, borderRadius: 1, p: 0.5, textAlign: 'center', minWidth: '40px' }}>
                        <Typography variant="body2" fontWeight={800} sx={{ color: statusColor }}>
                            {att.siglaattivita}
                        </Typography>
                    </Box>
                </Grid>

                {/* Data chiusura */}
                <Grid item xs={3} sm={2}>
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                        CHIUSURA
                    </Typography>
                    <Typography variant="body2" fontWeight={600} color="text.primary">
                        {formatDate(att.datachiusura)}
                    </Typography>
                </Grid>

                {/* Nome */}
                <Grid item xs={6} sm={4}>
                    <Typography variant="body1" fontWeight={500} color="text.primary" noWrap>
                        {att.nomeattivita}
                    </Typography>
                </Grid>

                {/* Prezzo unitario */}
                <Grid item xs={4} sm={1}>
                    <Typography variant="caption" color="text.secondary" display="block" textAlign="right" sx={{ mb: 0.5 }}>
                        PREZZO UNIT
                    </Typography>
                    <Typography variant="body2" fontWeight={600} textAlign="right">
                        {typeof att.valoreattivitaprogetto === 'number'
                            ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(att.valoreattivitaprogetto)
                            : formatCurrency(Number(att.valoreattivitaprogetto || 0))}
                    </Typography>
                </Grid>

                {/* Quantità */}
                <Grid item xs={6} sm={1}>
                    <Typography variant="caption" color="text.secondary" display="block" textAlign="right" sx={{ mb: 0.5 }}>
                        QTA
                    </Typography>
                    <Typography variant="body2" fontWeight={600} textAlign="right">
                        {att.quantita_attivita}
                    </Typography>
                </Grid>

                {/* Totale */}
                <Grid item xs={6} sm={3}>
                    <Box sx={{ pr: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <Typography variant="caption" color="text.secondary" display="block" textAlign="right" sx={{ mb: 0.5 }}>
                            TOTALE
                        </Typography>
                        <Box display="flex" alignItems="center">
                            {att.idfatturapilota ? (
                                <Tooltip title="Visualizza Fattura associata">
                                    <IconButton
                                        size="small"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            window.open(`/papi2/invoices/fattura/${att.idfatturapilota}/download`, '_blank');
                                        }}
                                        sx={{ mr: 1, color: '#ff9800' }}
                                    >
                                        <ReceiptIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            ) : null}
                            <Typography variant="h6" fontWeight={700} color="primary.main" textAlign="right">
                                {formatCurrency(total)}
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default AttivitaCard;